(function (app, ng) {

    app.config(["$stateProvider", function ($stateProvider) {
        $stateProvider.state("Register",
            {
                url: "/Register?state={currentToken}&authToken={token}&exists={userExists}",
                component: "register",
                PageTitle: "User Registration",
                resolve: {
                    onBefore: ["$stateParams", "userRegistrationApi", "$state", function ($stateParams, userRegistrationApi, $state) {
                        userRegistrationApi.getUserRegistrationByToken($stateParams.state).then(function (ur) {
                            if (Date.parse(ur.ExpirationDate) < Date.now()) {
                                $state.go("Invalid", { param: "expired" });
                            }
                            if (ur.Completed) {
                                $state.go("Login");
                            }
                        }, function () { $state.go("Invalid", { param: "invalid" }); });
                    }],
                    userRegistration: ["$stateParams", "userRegistrationApi", function ($stateParams, userRegistrationApi) {
                        return userRegistrationApi.getUserRegistrationByToken($stateParams.state);
                    }]
                }
            });
    }]);

    app.component("register",
        {
            templateUrl: "App/Register/template.html",
            controller: registerController,
            bindings: {
                userRegistration: "<"
            }

        });

    registerController.$inject = ["$stateParams", "portalBaseApiUrl"];
    function registerController($stateParams, portalBaseApiUrl) {
        var $ctrl = this;

        $ctrl.loading = true;
        redirectToFigAuth();

        function redirectToFigAuth() {
            var url = portalBaseApiUrl + "/UserRegistrations/Complete/Fig"
                + "?returnUrl=" + window.encodeURIComponent(window.location.protocol + "//" + window.location.host + "/Portal/Dashboard")
                + "&portalToken=" + window.encodeURIComponent($stateParams.state)
                + "&figAuthToken=" + window.encodeURIComponent($stateParams.authToken);
            if ($ctrl.userRegistration.UserGroupId)
                url += "&theme=" + $ctrl.userRegistration.UserGroupId;
            window.location = url;
        }
    }

})(window.app, window.angular);